import PartnerProduct from '@src/quince-site-common/src/domains/PartnerProduct'
import { getPathParams } from '@src/quince-site-common/src/utils/getPathParam'

import { QUERY_PARAM_TRACKER } from '../productCard/productCard.helpers'

export const getPartnerProductLink = (product: PartnerProduct, tracker: string | undefined = undefined) => {
  const params: Record<string, string> = {}

  if (tracker) {
    params[QUERY_PARAM_TRACKER] = tracker
  }

  if (product.slug) {
    return product.slug + getPathParams(params, '')
  }
  return undefined
}
